export default "__VITE_ASSET__BbvX7o9J__"